/**
 * Utility functions for getting Cloud Function URLs based on environment
 */

/**
 * Get the Cloud Function URL for a given function name
 * @param functionName - Name of the cloud function
 * @returns The full URL for the cloud function based on the current environment
 */
export async function getCloudFunctionUrl(functionName: string): Promise<string> {
  // Get the Cloud Function URL based on environment
  const rootConfig = await import('@root/firebase.env.js');
  const environment = rootConfig.default?.environment || rootConfig.environment || 'production';
  
  if (environment === 'development' || environment === 'staging') {
    return `https://europe-west1-gantty-staging.cloudfunctions.net/${functionName}`;
  } else {
    return `https://europe-west1-gantty-app.cloudfunctions.net/${functionName}`;
  }
}
